export enum QueryKeys {
  AppSettings = 'AppSettingsQueryKey',
  GlobalRateCard = 'GlobalRateCardQueryKey',
  GlobalRateCardEffectiveDates = 'GlobalRateCardEffectiveDatesQueryKey',
  OrganizationDiscountRateCard = 'OrganizationDiscountRateCardQueryKey',
  OrganizationRateCard = 'OrganizationRateCardQueryKey',
  Lodgements = 'LodgementsQueryKey',
  Users = 'UsersQueryKey',
  Products = 'ProductsQueryKey',
  ServiceCodes = 'ServiceCodesQueryKey',
  Branches = 'BranchesQueryKey',
  Organizations = 'OrganizationsQueryKey',
  LodgementTimelineActivities = 'LodgementTimelineActivitiesQueryKey',
  OrganizationApiKeys = 'OrganizationApiKeysQueryKey',
}